// /creator/shows — shows management in the creator AppShell (production zone,
// video surface). Shared component; see features/live/ShowsManager.
import { createFileRoute } from '@tanstack/react-router';

import { ShowsManager } from '@/features/live/ShowsManager';

export const Route = createFileRoute('/creator/shows')({
  component: ShowsManager,
});
